import React from "react";

export default function UserAnimation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="145"
      height="146"
      viewBox="0 0 145 146"
      fill="none"
    >
      <g filter="url(#filter0_d_1_2087)">
        <path
          d="M129.262 78.2149C134.355 45.2035 111.722 14.314 78.711 9.22122C45.6996 4.12848 14.81 26.761 9.71731 59.7724C4.62457 92.7838 27.2571 123.673 60.2685 128.766C93.28 133.859 124.169 111.226 129.262 78.2149Z"
          fill="#F5F9FF"
        />
        <path
          d="M108.466 103.262C98.8266 113.933 84.9214 120.683 69.407 120.683C53.8927 120.683 39.9875 113.933 30.3477 103.262C41.0968 94.7785 54.6426 89.6695 69.407 89.6695C84.1715 89.6695 97.7017 94.7785 108.466 103.262ZM69.407 78.811C82.4685 78.811 93.0458 68.2181 93.0458 55.1723C93.0458 42.1265 82.4529 31.5335 69.407 31.5335C56.3612 31.5335 45.7683 42.1265 45.7683 55.1723C45.7683 68.2181 56.3612 78.811 69.407 78.811Z"
          fill="url(#paint0_linear_1_2087)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_2087"
          x="0"
          y="0.505585"
          width="144.977"
          height="144.976"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.344948 0 0 0 0 0.0128472 0 0 0 0 0.616667 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_2087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_2087"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1_2087"
          x1="49.8461"
          y1="101.637"
          x2="203.131"
          y2="-51.6473"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stop-color="#FCCBF3" />
          <stop offset="1" stop-color="#72CDFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
